import Model, { attr } from '@ember-data/model';
import { uiTranslated } from 'admin-panel/utils/model';

import { type TranslatedField } from 'admin-panel/constants/types';

export default class GenreModel extends Model {
  @attr
  declare nameTranslations: TranslatedField;

  @uiTranslated
  declare name: string;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    genre: GenreModel;
  }
}
